/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserTrial } from './userTrial';

export type UserTrialProperty = UserTrial | null;
